var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Pane, Button, Row, Col, MessageBanner, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { RecekTextArea } from "../../components/inputs";
import { closePublisher, fetchPublisherData } from "../../api/publisherService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { hasAtLeastOneRole, useActiveRoles, } from "../../utils/permissionsUtils";
import { RoleEnum } from "../../types/RoleEnum";
import { publisherActionMessageId } from "../../utils/publisherActionError";
function PublisherClose(_a) {
    var _this = this;
    var internalNote = _a.internalNote;
    var history = useHistory();
    var location = useLocation();
    var id = useParams().id;
    var ky = useOkapiKy();
    var userRoles = useActiveRoles().roles;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(internalNote), note = _b[0], setNote = _b[1];
    var _c = useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    var publisherData = useQuery(["publisher", id], function () { return fetchPublisherData(id, ky); }, {
        enabled: !!id,
    }).data;
    useEffect(function () {
        var _a;
        if (publisherData) {
            setNote((_a = publisherData.internalComment) !== null && _a !== void 0 ? _a : "");
        }
    }, [publisherData]);
    var handleNoteChange = function (e) {
        setNote(e.target.value);
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var from, url, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    setErrorMessage(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, closePublisher(ky, id, note)];
                case 2:
                    _b.sent();
                    from = ((_a = location.state) !== null && _a !== void 0 ? _a : {}).from;
                    if (from) {
                        url = new URL(from);
                        url.searchParams.delete("detail");
                        history.push(url.pathname + url.search);
                    }
                    else {
                        history.goBack();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error("Error closing publisher:", error_1);
                    // RECEK-76282: the failure is shown, e.g. the refusal of another publisher than the own one
                    setErrorMessage(formatMessage({
                        id: publisherActionMessageId(error_1, "ui-br-publishers.publishers.error.close"),
                    }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var isPublisher = hasAtLeastOneRole(userRoles, [
        RoleEnum.PUBLISHER_ADMIN,
        RoleEnum.PUBLISHER_GUARANTOR,
    ]);
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-publishers.publishers.close.pane.title",
            }) },
            React.createElement(MessageBanner, { dismissible: true, onExited: function () { return setErrorMessage(null); }, show: errorMessage !== null, type: "error" }, errorMessage),
            React.createElement("form", { onSubmit: handleSubmit },
                !isPublisher ? (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(RecekTextArea, { labelId: "ui-br-publishers.publishers.accordion.label.comments", value: note, onChange: handleNoteChange })))) : null,
                React.createElement(Row, { end: "xs", style: { marginTop: "20px" } },
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(Button, { buttonStyle: "primary", type: "submit", fullWidth: true }, !isPublisher
                            ? formatMessage({
                                id: "ui-br-publishers.button.closePublisher.confirm",
                            })
                            : formatMessage({
                                id: "ui-br-publishers.button.closePublisher.confirm.long",
                            }))),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); }, fullWidth: true }, formatMessage({ id: "ui-br-publishers.button.back" }))))))));
}
export default PublisherClose;
